/**
 * Copyright (c) 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { getAuthData } from '../../util/storage';
import { ICustomRouteProps } from '../../navigation/interfaces';

export const PrivateRoute = (props: ICustomRouteProps) => {
  const { component, ...rest } = props;
  const authToken = getAuthData();

  if (authToken && authToken.token) {
    return <Route {...rest} component={component} />;
  }

  return <Redirect to={{ pathname: '/login' }} />;
};
